import { useState } from 'react';

const faqs = [
  {
    id: 1,
    q: '被窝影院真的完全免费吗？',
    a: '是的，被窝影院所有电影资源均免费提供在线观看，无需支付任何费用。我们通过技术优化和资源整合，让每一位影迷都能享受零成本的观影体验。无需注册、无需会员，打开就能看。',
  },
  {
    id: 2,
    q: '观看电影需要下载播放器或插件吗？',
    a: '完全不需要。被窝影院采用先进的在线流媒体技术，直接在浏览器中就能流畅播放。无论是电脑、平板还是手机，只要连接网络就能随时随地观看，无需安装任何额外软件或插件。',
  },
  {
    id: 3,
    q: '电影画质怎么样？支持超清播放吗？',
    a: '我们提供从标清到超清的多档画质选择，大部分影片支持1080P高清甚至4K超清画质。播放器3.0版本上线后，画质切换更加流畅智能，会根据你的网络状况自动匹配最佳清晰度。',
  },
  {
    id: 4,
    q: '为什么被窝影院没有广告？',
    a: '我们坚持纯净观影的理念，通过技术手段和资源优化来维持平台运营，不对用户展示任何形式的弹窗广告、贴片广告或插屏广告。你可以享受无缝、沉浸的观影体验，不被任何商业信息打扰。',
  },
  {
    id: 5,
    q: '影片更新频率如何？新片多久能上线？',
    a: '被窝影院的资源团队每日更新片库，热门院线电影下线后通常在一周内完成高清版本的更新。除此之外，经典老片、高分佳作也在持续补全中，确保片库越来越丰富。',
  },
  {
    id: 6,
    q: '遇到播放卡顿或无法加载怎么办？',
    a: '如果遇到播放问题，可以尝试切换播放线路（通常提供2-3条备选线路），或者降低画质档位。我们的多线路负载均衡系统会自动调配最优线路，绝大多数情况下都能保证流畅播放。如仍有问题，欢迎通过联系方式反馈。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">关于被窝影院，你可能想了解的问题都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq) => (
            <FAQItem key={faq.id} faq={faq} defaultOpen={faq.id === 1} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ faq, defaultOpen }: { faq: typeof faqs[0]; defaultOpen: boolean }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
      <button
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 flex-1">{faq.q}</h3>
        <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${isOpen ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-500'}`}>
          <i className="ri-arrow-down-s-line text-sm"></i>
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
        <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
      </div>
    </div>
  );
}